import React from 'react';
import { Typography } from 'fronton-react';
import { MainProductArt } from '../MainProduct/styles';

type TProps = {
  productId: string | undefined;
};

export const ProductArticle = ({ productId }: TProps) => (
  <>
    {productId ? (
      <MainProductArt>
        <Typography size="caption" variant="minor" color="text-minor">
          Арт.
        </Typography>
        <Typography size="caption" variant="minor" color="text-minor">
          {` ${productId}`}
        </Typography>
      </MainProductArt>
    ) : null}

    {
      // расскоментить когда будем получать вес товара
      /* <Typography size="caption" variant="minor" color="text-primary">
            •
          </Typography>
          <MainProductWeight>
            <Typography size="caption" variant="minor" color="text-primary">
              Вес –
            </Typography>
            <Typography size="caption" variant="minor" color="text-secondary">
              100,1 кг
            </Typography>
          </MainProductWeight> */
    }
  </>
);
